'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Keyshape = function (_Component) {
  _inherits(Keyshape, _Component);

  function Keyshape(props) {
    _classCallCheck(this, Keyshape);

    var _this = _possibleConstructorReturn(this, (Keyshape.__proto__ || Object.getPrototypeOf(Keyshape)).call(this, props));

    _this.loadSvg = _this.loadSvg.bind(_this);
    _this.loadScript = _this.loadScript.bind(_this);
    _this.XMLToString = _this.XMLToString.bind(_this);
    _this.getXMLDoc = _this.getXMLDoc.bind(_this);
    _this.path = _this.props.svg.split("/");
    _this.state = {
      "id": _this.path[_this.path.length - 1].split(".")[0],
      "addScriptToDOM": false,
      "shouldComponentUpdate": true
    };
    return _this;
  }

  _createClass(Keyshape, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadSvg();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      //debugger;
      if (this.state.addScriptToDOM) {
        this.loadScript();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      //debugger;
      return nextState.shouldComponentUpdate;
    }
  }, {
    key: 'loadSvg',
    value: function loadSvg() {
      var _this2 = this;

      _axios2.default.get(this.props.svg).then(function (response) {
        var doc = _this2.getXMLDoc(response.data, "image/svg+xml");

        var childNodes = doc.getElementsByTagName("svg")[0].childNodes;

        for (var i = 0; i < childNodes.length; i++) {
          if (childNodes[i].toString() == "[object SVGScriptElement]") {
            childNodes[i].parentNode.removeChild(childNodes[i]);
          }
        }

        _this2.instance.appendChild(doc.documentElement);

        _this2.setState({
          "addScriptToDOM": true
        }); //console.log("Added svg!")

      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: 'loadScript',
    value: function loadScript() {
      var _this3 = this;

      _axios2.default.get(this.props.svg).then(function (response) {
        var doc = _this3.getXMLDoc(response.data, "image/svg+xml");

        var childNodes = doc.getElementsByTagName("svg")[0].childNodes;
        var scriptNodes = [];

        for (var i = 0; i < childNodes.length; i++) {
          if (childNodes[i].toString() == "[object SVGScriptElement]") {
            scriptNodes.push(childNodes[i]);
          }
        }

        for (var j = 0; j < scriptNodes.length; j++) {
          var s_scriptNode = _this3.XMLToString(scriptNodes[j]); //debugger;


          s_scriptNode = s_scriptNode.replace("<script xmlns=\"http://www.w3.org/2000/svg\"><![CDATA[", "").replace("]]></script>", "");
          var scriptDOMNode = document.createElement('script');
          scriptDOMNode.async = true;
          scriptDOMNode.innerHTML = s_scriptNode;

          _this3.instance.appendChild(scriptDOMNode);

          if (_this3.props.callback) {
            var wrapper = function wrapper() {
              var player = window.ks;
              window.Keyshape = window.Keyshape || {};
              window.Keyshape.players = window.Keyshape.players || [];
              window.Keyshape.players[_this3.instance.id] = {
                player: player
              };

              _this3.props.callback(player, _this3.instance);
            };

            wrapper();
          }

          _this3.setState({
            "addScriptToDOM": false,
            "shouldComponentUpdate": false
          });
        } //console.log("Added script!");

      }).catch(function (error) {
        console.log(error);
      });
    }
  }, {
    key: 'XMLToString',
    value: function XMLToString(xml) {
      if (window.ActiveXObject) {
        var str = xml.xml;
        return str;
      } else {
        return new XMLSerializer().serializeToString(xml);
      }
    }
  }, {
    key: 'getXMLDoc',
    value: function getXMLDoc(str, type) {
      var xmlDoc;

      if (window.DOMParser) {
        var parser = new DOMParser();
        xmlDoc = parser.parseFromString(str, "image/svg+xml");
      } else {
        // Internet Explorer
        xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
        xmlDoc.async = false;
        xmlDoc.loadXML(str);
      }

      return xmlDoc;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement('div', {
        id: this.state.id,
        ref: function ref(el) {
          return _this4.instance = el;
        },
        className: 'keyshape-svg'
      });
    }
  }]);

  return Keyshape;
}(_react.Component);

exports.default = Keyshape;